import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import './index.scss';

import SearchBox from '../SearchBox';
import AmountControl from '../AmountControl';
import Waiter from "../Waiter/Waiter.jsx";
import {ReportType, WAITER_TYPES} from "../../../utils/enums.js";
import ExportFileControl from '../ExportFileControl/ExportFileControl.jsx';
import { CUSTOMERS_GET_REPORT } from '../../../store/reducers/customer/customer-actions.js';
import ReportModalDateRange from '../ReportModalDateRange/ReportModalDateRange.jsx';

const CustomersListHeader = ({ filter, onSetFilter, customers, withLabel = true, withExelIcon = true, addIcon = false, onClickAdd }) => {
  const { t } = useTranslation();
  const [isOpenForm, setIsOpenForm] = useState(false);

  const handleOnSearch = search => {
    onSetFilter({ ...filter, search });
  };

  return (
    <div className={classNames('customersListHeader')}>
      {withLabel && (
        <div className={classNames('customersListHeaderTitle')}>
          {addIcon ? (
              <div className={"createNewUser"} onClick={onClickAdd}>
                <Waiter type={WAITER_TYPES.span}
                        spanText={"+"}
                        tooltipText={t("edit-customer-order.aboutClient.CREATE_USER")}
                />
              </div>
          ): <div/>}

          <span className={classNames('headerTitle')}>
            {t('customers.LABEL')}
          </span>

          <AmountControl value={customers.length} />
        </div>
      )}
      <div className={classNames('customersListHeaderData')}>
        <div className={classNames('customersListHeaderSearch')}>
          <SearchBox
            placeholder={t('orders.SEARCH_PLACEHOLDER')}
            useValue={(filter || {}).search}
            onChange={handleOnSearch}
          />
        </div>
        {withExelIcon && (
          <ExportFileControl
            FilterForm={ReportModalDateRange}
            filterFormProps={{
              isOpen: isOpenForm,
              setIsOpen: setIsOpenForm,
            }}
            canSavePdfReport
            hideText 
            control={{reportType: ReportType.Consumers, action: CUSTOMERS_GET_REPORT, pdfReportType: ReportType.MarketplaceConsumerEngagement, actionFn: () => setIsOpenForm(true)}} 
            model={filter} 
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  customers: state.customer.customers || [],
});

export default connect(mapStateToProps)(CustomersListHeader);
